export default "//uniclient-edge-assets.lmndstaging.com/customer-support__at__f0bd4c2fbf8531fd68116504b3c745fb.svg"